import { MeasureType, ROUTE_LOADS } from '@/common/constants';
import { ContractStatusesEnum } from '@/common/constants/contract.statuses';
import { Button } from '@/components/ui/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useLoadStore } from '../../store';
import { AnalysisGrainData } from './AnalysisGrainData';

export const AnalysisGrainWrapper: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { loadGrain } = useLoadStore();

  const isDeleted =
    loadGrain?.farmer_contract_status === ContractStatusesEnum.DELETED ||
    loadGrain?.farmer_contract_status === ContractStatusesEnum.CANCELED;

  return (
    <div className="border-t border-gray-300 pt-8 mt-4">
      <h3 className="text-lg font-medium mb-4">{t('lab.facility')}</h3>
      <AnalysisGrainData load={loadGrain} />

      {!loadGrain?.analysis?.analysis_date &&
        !loadGrain?.cancel_request &&
        loadGrain?.current_status !== MeasureType.ENTRY &&
        loadGrain?.current_status !== MeasureType.COMPLETE && (
          <Button
            variant="outline"
            disabled={isDeleted}
            onClick={() =>
              navigate(`${ROUTE_LOADS}/analysis-grain/${loadGrain?.id}`)
            }
            className="font-medium flex-h-center mt-5"
          >
            <span>{t('add.lab.facility')}</span>
          </Button>
        )}
    </div>
  );
};
